import { jsxs, jsx } from "react/jsx-runtime";
import { styled } from "@mui/material";
import { getEntityImage } from "../../../utils/assetUtils.js";
const IconGroupContainer = styled("div")({
  "*": {
    mixBlendMode: "unset !important"
  },
  ".hidden-counts": {
    marginLeft: 7,
    fontWeight: 600
  },
  ".logos": {
    display: "flex",
    alignItems: "center"
  },
  display: "flex",
  alignItems: "center"
});
const RetailerIconGroup = ({
  retailerIds,
  maxSize = 4,
  iconSize = 18,
  buildUnrenderedIconCountString = (hiddenIconCount) => `+${hiddenIconCount}`
}) => {
  const retailerIdsToRender = retailerIds.slice(0, maxSize);
  const hiddenIconCount = retailerIds.length - maxSize;
  return /* @__PURE__ */ jsxs(IconGroupContainer, { style: {}, children: [
    /* @__PURE__ */ jsx(
      "div",
      {
        className: "logos",
        style: {
          width: retailerIdsToRender.length * iconSize - iconSize * 0.46 * (retailerIdsToRender.length - 1)
        },
        children: retailerIdsToRender.map((retailerId, index) => {
          const shiftOffset = iconSize * 0.46;
          return /* @__PURE__ */ jsx(
            "img",
            {
              src: getEntityImage(retailerId, "retailer"),
              alt: "retailer-logo",
              style: {
                width: iconSize,
                height: iconSize,
                objectFit: "contain",
                borderRadius: 999,
                fontSize: 10,
                position: "relative",
                left: -shiftOffset * index,
                zIndex: retailerIdsToRender.length - index
              }
            },
            `retailer-logo-${retailerId}`
          );
        })
      }
    ),
    hiddenIconCount >= 1 ? /* @__PURE__ */ jsx("div", { className: "hidden-counts", style: { fontSize: 11 }, children: buildUnrenderedIconCountString(hiddenIconCount) }) : null
  ] });
};
export {
  RetailerIconGroup
};
//# sourceMappingURL=index.js.map
